import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Article2() {
  const { t } = useTranslation();
  
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="article-page">
      <div className="article-header" data-aos="fade-up">
        <h1 className="article-title">{t("articles.article2.title")}</h1>
      </div>
      
      <div className="article-content" data-aos="fade-up">
        <div className="article-images">
          <img 
            src="/images/article2-img1.jpeg" 
            alt="Superwood material" 
            className="article-image"
            data-aos="zoom-in"
          />
          <img 
            src="/images/article2-img2.jpeg" 
            alt="Engineered wood technology" 
            className="article-image"
            data-aos="zoom-in"
            data-aos-delay="200"
          />
        </div>
        
        <div className="article-text" data-aos="fade-up">
          <p>{t("articles.article2.paragraph1")}</p>
          <p>{t("articles.article2.paragraph2")}</p>
        </div>
      </div>
    </div>
  );
}

